import { Crown, Diamond, Sparkle } from "lucide-react";

const COLORS = ["#ff6574", "#ffa353", "#f5d978", "#62f09a", "#71e3ed", "#739cff", "#bc91ed"];
const PIECES = Array.from({ length: 28 }, (_, i) => ({
  x: Math.cos((i / 28) * Math.PI * 2) * (38 + (i % 3) * 7),
  y: Math.sin((i / 28) * Math.PI * 2) * 43 - 12,
  hue: COLORS[i % COLORS.length], kind: i % 7,
}));

export const PortfolioRainbow = ({ celebrating, count }) => (
  <div className="pf-lucky-atmosphere" aria-hidden="true" data-testid="portfolio-prismatic-atmosphere">
    <div className="pf-lucky-whisper" />
    <i className="pf-lucky-idle-spark pf-lucky-idle-spark--one" />
    <i className="pf-lucky-idle-spark pf-lucky-idle-spark--two" />
    {celebrating && <div key={count} className="pf-lucky-burst" data-testid="portfolio-rainbow-celebration">
      <div className="pf-lucky-charge" data-testid="portfolio-rainbow-energy-core" />
      <div className="pf-lucky-shockwave" />
      <div className="pf-lucky-rays" />
      <svg className="pf-lucky-arc" viewBox="0 0 1000 450" preserveAspectRatio="none" focusable="false" data-testid="portfolio-rainbow-arc">
        {COLORS.map((color, i) => <path key={color} d={`M${60 + i * 12} 420 A${440 - i * 12} ${350 - i * 11} 0 0 1 ${940 - i * 12} 420`}
          fill="none" stroke={color} strokeWidth="6" />)}
      </svg>
      {PIECES.map(({ x, y, hue, kind }, i) => {
        const Icon = kind === 0 ? Crown : kind === 1 ? Diamond : kind === 2 ? Sparkle : null;
        return <span key={i} className={`pf-lucky-piece pf-lucky-piece--${kind}`} style={{ "--dx": `${x}cqw`, "--dy": `${y}cqh`, "--hue": hue, "--spin": `${(i % 2 ? -1 : 1) * (80 + i * 9)}deg`, "--delay": `${(i % 4) * 35}ms` }}>
          {Icon ? <Icon /> : <i />}
        </span>;
      })}
    </div>}
  </div>
);